<template>
  <div
    v-if="loading"
    class="section"
  >
    <div class="container">
      <div class="loader" />
    </div>
  </div>

  <!-- Tip Payment Receipt -->
  <div v-else-if="$route.params.receiptToken">
    <div class="section section--alt-background">
      <div class="container flex-column align-center">
        <img
          v-if="content.MobileTippingReceipt.metadata.imageUrl"
          :src="content.MobileTippingReceipt.metadata.imageUrl"
          alt="receipt-image"
          class="max-width-mobile extra-padding-x image image--auto-w"
        >
        <span
          v-else
          class="icon icon--medium fa fa-check-circle far primary spacing"
        />

        <p class="total light-gray">
          <span class="total__title">
            <span class="total__title-text">
              YOU TIPPED
            </span>
          </span>
          <span class="total__amount primary">
            {{ $dollars(receipt.tip) }}
          </span>
        </p>

        <p class="title title--6">{{ content.MobileTippingReceipt.metadata.paymentSubtitle }}</p>
      </div>
    </div>
    <div class="section">
      <div class="container max-width-mobile">
        <validated-form
          name="sendReceipt"
          @valid-submit="sendReceipt"
        >
          <h2 class="title title--4 bold primary center">
            {{ content.MobileTippingReceipt.metadata.sendReceiptTitle }}
          </h2>
          <text-input
            v-model="email"
            type="email"
            label="Email"
            name="email"
            :validations="{ required: !phone }"
          />
          <text-input
            v-model="phone"
            type="phone"
            label="Text"
            name="phone"
            :validations="{ required: !email }"
          />
          <button
            type="submit"
            :class="[
              'button button--primary button',
              { 'button--loading': $store.state.receipt.receiptIsSending }
            ]"
          >
            Send Receipt
          </button>
        </validated-form>

        <template v-if="payment">
          <h2 class="title title--section">PAID WITH</h2>
          <div class="flex align-center justify-between half-spacing">
            <p
              v-if="payment.paymentType === 'RoomCharge'"
              class="no-spacing bold"
            >
              Charged To Room
            </p>
            <div
              v-else
              class="flex align-center half-gap bold"
            >
              <card-type-icon
                :card-type="payment.cardType"
                :payment-type="payment.paymentType"
              />
              <span>••••</span>
              <span>
                {{ payment.cardNumberLastFour }}
              </span>
            </div>
            <p class="no-spacing">
              {{ $dollars(receipt.tip) }}
            </p>
          </div>
          <div class="flex justify-between">
            <p class="bold">Payment Date</p>
            <p>{{ $moment(payment.localPaymentDate, 'MMM Do, YYYY h:mm A') }}</p>
          </div>
        </template>
      </div>
    </div>
  </div>

  <!-- Survey Only Receipt -->
  <div
    v-else
    class="section"
  >
    <div class="container center max-width-mobile flex-column align-center">
      <img
        v-if="content.MobileTippingReceipt.metadata.imageUrl"
        :src="content.MobileTippingReceipt.metadata.imageUrl"
        alt="receipt-image"
        class="max-width-mobile extra-padding-x image image--auto-w"
      >
      <span
        v-else
        class="icon icon--large fa fa-check-circle far primary spacing"
      />
      <p class="title title--2">
        {{ content.MobileTippingReceipt.metadata.noPaymentTitle }}
      </p>
      <p>
        {{ content.MobileTippingReceipt.metadata.noPaymentSubtitle }}
      </p>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'TipReceiptPage',

    metaInfo() {
      return {
        title: 'Tip Receipt'
      };
    },

    data: () => ({
      loading: false,
      email: null,
      phone: null
    }),

    computed: {
      ...mapGetters('content', ['content']),
      ...mapGetters('receipt', ['receipt']),

      payment() {
        return this.receipt?.payments[0];
      }
    },

    created() {
      this.fetchReceipt();
    },

    methods: {
      async fetchReceipt() {
        if (this.$route.params.receiptToken) {
          this.loading = true;
          await this.$store.dispatch('receipt/getReceipt', {
            receiptToken: this.$route.params.receiptToken
          });
          this.loading = false;
        }
      },

      sendReceipt() {
        this.$store.dispatch('receipt/sendReceipt', {
          communicationName: 'CustomerMobileTippingReceipt',
          email: this.email,
          phone: this.phone,
          receiptToken: this.$route.params.receiptToken
        });
      }
    }
  };
</script>
